"use client";

import { Check, X, Pencil } from "lucide-react";
import { useState } from "react";

import { Button, Input } from "@/components/ui";

interface EditableFieldProps {
  value: string | number;
  onSave: (value: string | number) => void;
  type?: "text" | "number";
  className?: string;
}

export function EditableField({
  value,
  onSave,
  type = "text",
  className = "",
}: EditableFieldProps) {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(value);

  const handleSave = () => {
    onSave(editValue);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setEditValue(value);
    setIsEditing(false);
  };

  if (!isEditing) {
    return (
      <div className={`group relative inline-block ${className}`}>
        <span>{value}</span>
        <Button
          variant="ghost"
          size="sm"
          className="absolute -right-8 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity"
          onClick={() => setIsEditing(true)}
        >
          <Pencil className="h-4 w-4" />
        </Button>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 animate-fade-in">
      <Input
        type={type}
        value={editValue}
        onChange={(e) =>
          setEditValue(
            type === "number" ? Number(e.target.value) : e.target.value
          )
        }
        className="h-8 w-auto min-w-[100px]"
        autoFocus
      />
      <Button size="sm" variant="ghost" onClick={handleSave}>
        <Check className="h-4 w-4" />
      </Button>
      <Button size="sm" variant="ghost" onClick={handleCancel}>
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
}
